import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

function scrollBgScale() {
  gsap.registerPlugin(ScrollTrigger);
  const targets = gsap.utils.toArray(".is-biz-bg\\:scale");
  targets.forEach((target) => {
    gsap.to(target, {
      "--bg-scale": 1,
      // ease: "power4.inOut",
      // duration: .8,
      scrollTrigger: {
        trigger: target,
        start: "top 90%",
        end: "top 30%",
        scrub: true,
        // toggleActions: "play none none reverse",
        // markers: true,
      }
    })
  })
}

export {scrollBgScale}
